var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{},[_c('div',{staticClass:"text-center text-light small",class:{
      'bg-success': _vm.missedPings === 0,
      'bg-warning': _vm.missedPings >= 1 && _vm.missedPings < 3,
      'bg-danger': _vm.missedPings >= 3
    }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }